import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "date-of-birth" }, [
  /*#__PURE__*/_createTextVNode(" Start of Care Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "input-group date datepickerInput" }
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "date-of-birth" }, [
  /*#__PURE__*/_createTextVNode(" Episode Start Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_12 = { class: "input-group date datepickerInput" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_15 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_16 = { class: "col-12 py-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center field-title" }, " Create episode & schedule visit after saving ", -1 /* HOISTED */)
const _hoisted_19 = { class: "form-check d-flex custom-checkbox pb-1 col-12" }
const _hoisted_20 = ["id", "value", "checked", "onChange"]
const _hoisted_21 = ["for"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "form-check d-flex pb-1 col-12 ms-4 mt-2 mb-2" }
const _hoisted_24 = ["id", "value", "onChange", "checked"]
const _hoisted_25 = ["for"]
const _hoisted_26 = {
  key: 0,
  class: "form-group col-12 ps-4 mt-2 mb-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, " Recertification Date ", -1 /* HOISTED */)
const _hoisted_28 = { class: "input-group date datepickerInput" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_31 = { class: "form-check d-flex pb-1 col-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-1 col-12",
  for: "IsFaceToFaceEncounterCreated"
}, " Track F2F Documentation ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Episode Management",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("input", {
                        name: "StartofCareDate",
                        type: "text",
                        class: _normalizeClass(`form-control ${
                                                _ctx.v$.referral.Demographics.StartofCareDate.$error ||
                                                _ctx.errors.Demographics.includes('StartofCareDate')
                                                    ? 'border border-warning rounded p-2'
                                                    : ''
                                            }`),
                        placeholder: "Enter Date",
                        value: _ctx.formatDateInput(_ctx.referral.Demographics.StartofCareDate),
                        onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.StartofCareDate.$touch && _ctx.v$.referral.Demographics.StartofCareDate.$touch(...args))),
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                        autocomplete: "off"
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_8),
                      _hoisted_9
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("input", {
                        name: "EpisodeStartDate",
                        type: "text",
                        class: _normalizeClass(`form-control ${
                                                _ctx.v$.referral.Demographics.EpisodeStartDate.$error ||
                                                _ctx.errors.Demographics.includes('EpisodeStartDate')
                                                    ? 'border border-warning rounded p-2'
                                                    : ''
                                            }`),
                        placeholder: "Enter Date",
                        value: _ctx.formatDateInput(_ctx.referral.Demographics.EpisodeStartDate),
                        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.EpisodeStartDate.$touch && _ctx.v$.referral.Demographics.EpisodeStartDate.$touch(...args))),
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                        autocomplete: "off"
                      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_13),
                      _hoisted_14
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", {
                class: _normalizeClass(`${
                                    _ctx.v$.referral.Demographics.CreateEpisodeAndScheduleVisit.$error ||
                                    _ctx.errors.Demographics.includes('CreateEpisodeAndScheduleVisit')
                                        ? 'border border-warning p-2 rounded'
                                        : ''
                                }`)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Options, (option) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${option.value}-${option.label}`
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: `${option.value}-${option.label}`,
                        value: option.value,
                        checked: _ctx.isChecked(option),
                        onChange: ($event: any) => (_ctx.handleEpisodeChange(option.value)),
                        onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.CreateEpisodeAndScheduleVisit.$touch && _ctx.v$.referral.Demographics.CreateEpisodeAndScheduleVisit.$touch(...args)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20),
                      _createElementVNode("label", {
                        class: "form-check-label ms-1 col-12",
                        for: `${option.value}-${option.label}`
                      }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_21)
                    ]),
                    (_ctx.referral.Demographics.CreateEpisodeAndScheduleVisit === option.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OasisDisciplineTypeOptions[
                                                _ctx.referral.Demographics.CreateEpisodeAndScheduleVisit
                                            ], (type) => {
                            return (_openBlock(), _createElementBlock("div", null, [
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("input", {
                                  type: "radio",
                                  class: "form-check-input",
                                  id: `${type.value}-${type.label}`,
                                  value: type.value,
                                  onChange: ($event: any) => (_ctx.handleOasisType(type.value)),
                                  checked: _ctx.referral.Demographics.OasisDisciplineType === type.value
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_24),
                                _createElementVNode("label", {
                                  class: "form-check-label ms-1 col-12",
                                  for: `${type.value}-${type.label}`
                                }, _toDisplayString(type.label), 9 /* TEXT, PROPS */, _hoisted_25)
                              ])
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */)),
                          (
                                                _ctx.referral.Demographics.CreateEpisodeAndScheduleVisit === 5 ||
                                                _ctx.referral.Demographics.CreateEpisodeAndScheduleVisit === 4
                                            )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _hoisted_27,
                                _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("input", {
                                        name: "recert-Date",
                                        type: "text",
                                        class: "form-control",
                                        placeholder: "Enter Date",
                                        value: 
                                                            _ctx.formatDateInput(_ctx.referral.Demographics.RecertificationDate)
                                                        ,
                                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                                        autocomplete: "off"
                                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_29),
                                      _hoisted_30
                                    ])
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["getDate"])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: "IsFaceToFaceEncounterCreated",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.Demographics.IsFaceToFaceEncounterCreated) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.referral.Demographics.IsFaceToFaceEncounterCreated]
                  ]),
                  _hoisted_32
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}